import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { SPEC_VERSION } from "../data/specs";

const CARAMEL = [217, 119, 54];
const INK = [18, 18, 18];
const MUTED = [115, 115, 115];
const PAGE_W = 210;
const MARGIN = 16;

const clean = (s) =>
  String(s)
    .replace(/⁰/g, "^0").replace(/¹/g, "^1").replace(/²/g, "^2")
    .replace(/³/g, "^3").replace(/⁴/g, "^4").replace(/⁵/g, "^5")
    .replace(/⁶/g, "^6");

const drawHeader = (doc, docType, product) => {
  doc.setFillColor(...CARAMEL);
  doc.rect(0, 0, PAGE_W, 3.5, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(19);
  doc.setTextColor(...INK);
  doc.text("MSD FOODS", MARGIN, 16);

  doc.setFontSize(8.5);
  doc.setTextColor(...MUTED);
  doc.setFont("helvetica", "normal");
  doc.text("Manufacturers & Exporters — Food Powders", MARGIN, 21.5);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(...CARAMEL);
  doc.text(docType, PAGE_W - MARGIN, 16, { align: "right" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...MUTED);
  doc.text(`${product.sdsNo}  ·  Rev ${SPEC_VERSION.version}  ·  ${SPEC_VERSION.issueDate}`, PAGE_W - MARGIN, 21.5, { align: "right" });

  doc.setDrawColor(225, 225, 225);
  doc.line(MARGIN, 26, PAGE_W - MARGIN, 26);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.setTextColor(...INK);
  doc.text(clean(product.name), MARGIN, 35);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...MUTED);
  doc.text(clean(product.description), MARGIN, 41);

  return 47;
};

const drawFooters = (doc) => {
  const pages = doc.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    doc.setDrawColor(225, 225, 225);
    doc.line(MARGIN, 287, PAGE_W - MARGIN, 287);
    doc.setFontSize(7.5);
    doc.setTextColor(...MUTED);
    doc.text("MSD Foods · G.I.D.C. Vatva, Ahmedabad - 382 445, India · +91 99136 16190 · msdfoods21@gmail.com", MARGIN, 292);
    doc.text(`Page ${i} of ${pages}`, PAGE_W - MARGIN, 292, { align: "right" });
  }
};

const slug = (name) => name.replace(/[^a-z0-9]+/gi, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");

export const downloadCoaPdf = (product) => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const startY = drawHeader(doc, "CERTIFICATE OF ANALYSIS", product);

  autoTable(doc, {
    startY,
    margin: { left: MARGIN, right: MARGIN },
    head: [["Parameter", "Specification", "Reference"]],
    body: product.coa.map((row) => [clean(row.param), clean(row.value), row.ref ? clean(row.ref) : "—"]),
    styles: { font: "helvetica", fontSize: 9, cellPadding: 3, textColor: INK, lineColor: [230, 230, 230], lineWidth: 0.1 },
    headStyles: { fillColor: CARAMEL, textColor: [255, 255, 255], fontStyle: "bold", fontSize: 8.5 },
    alternateRowStyles: { fillColor: [248, 248, 248] },
    columnStyles: { 0: { cellWidth: 45, fontStyle: "bold" }, 2: { cellWidth: 32, textColor: MUTED } },
  });

  if (product.category === "caramel") {
    const y = doc.lastAutoTable.finalY + 6;
    doc.setFontSize(8);
    doc.setTextColor(...MUTED);
    doc.text("* Internal proposed QC limit; verify applicable regulation.", MARGIN, y);
  }

  drawFooters(doc);
  doc.save(`MSD-Foods_${product.sdsNo}_${slug(product.name)}_COA.pdf`);
};

export const downloadMsdsPdf = (product) => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const startY = drawHeader(doc, "SAFETY DATA SHEET", product);
  const m = product.msds;

  const rows = [
    ["01 — Hazard Identification", clean(m.hazard)],
    ["02 — Composition / Ingredients", clean(m.composition)],
    ["03 — First-Aid Measures", m.firstAid.map((f) => `${f.route}: ${f.action}`).join("\n")],
    ["04 — Handling & Storage", clean(m.handling)],
    ["05 — Physical & Chemical Properties", m.properties.map((p) => `${p.param}: ${clean(p.value)}`).join("\n")],
    ["06 — Stability & Reactivity", clean(m.stability)],
    ["07 — Disposal Considerations", clean(m.disposal)],
    ["08 — Transport Information", clean(m.transport)],
  ];

  autoTable(doc, {
    startY,
    margin: { left: MARGIN, right: MARGIN },
    head: [["Section", "Details"]],
    body: rows,
    styles: { font: "helvetica", fontSize: 9, cellPadding: 3.5, textColor: INK, lineColor: [230, 230, 230], lineWidth: 0.1 },
    headStyles: { fillColor: CARAMEL, textColor: [255, 255, 255], fontStyle: "bold", fontSize: 8.5 },
    columnStyles: { 0: { cellWidth: 52, fontStyle: "bold", valign: "top" } },
  });

  drawFooters(doc);
  doc.save(`MSD-Foods_${product.sdsNo}_${slug(product.name)}_MSDS.pdf`);
};
